import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderReview = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17 21C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17Z",
				stroke: "var(--main-color)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 3C8 3 9 7 10 7H14C15 7 16 3 16 3",
				stroke: "var(--main-color)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 15L11 17L15 12",
				stroke: "var(--main-color)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export { SvgOrderReview as ReactComponent };
